import type { ReactNode } from 'react';

export const symbol_vital_signs: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M334-199q-13-9-18-23l-97-228H78q-13 0-21.5-8.5T48-480q0-13 8.5-21.5T78-510h163q9 0 16 5t11 13l95 223 187-467q5-14 18-23t29-9q16 0 29 9t18 23l97 226h141q13 0 21.5 8.5T912-480q0 13-8.5 21.5T882-450H719q-9 0-16-5t-11-13l-95-221-187 467q-5 14-18 23t-29 9q-16 0-29-9Z"
		/>
	</svg>
);
